import clsx from 'clsx';
import styles from './Grid.module.scss';

interface GridProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    style?: React.CSSProperties;
    flow?: 'row' | 'column';
    rows?: string;
    rowSize?: string;
    columns?: string;
    columnSize?: string;
    columnGap?: 'extrasmall' | 'small' | 'medium' | 'large';
    rowGap?: 'extrasmall' | 'small' | 'medium' | 'large';
    inline?: boolean;
    children?: React.ReactNode;
}

export const Grid = ({
    className,
    style,
    rows,
    columns,
    rowSize,
    columnSize,
    flow,
    columnGap,
    rowGap,
    inline,
    children,
    ...rest
}: GridProps) => {
    const inlineStyle = {
        ...style,
        '--grid-template-rows': rows,
        '--grid-template-columns': columns,
        '--grid-auto-rows': rowSize,
        '--grid-auto-columns': columnSize,
        '--grid-auto-flow': flow,
    };

    return (
        <div
            {...rest}
            style={inlineStyle}
            className={clsx(
                styles.grid,
                {
                    [styles.inline]: inline,
                    [styles['columnGap' + columnGap]]: !!columnGap,
                    [styles['rowGap' + rowGap]]: !!rowGap,
                },
                className,
            )}
        >
            {children}
        </div>
    );
};
